import { useCallback, useEffect } from 'react';

import useTopics from './useTopics';
import { PARAM_SUGGESTED_FOR_USER } from '../constants/queryParams';
import { SUGGESTED_TOPICS } from '../constants/types';
import { useTopicsIndexContext } from '../contexts/TopicsIndexContext';

const useTopicsSuggestedTopics = () => {
  const { totalAllTopics, setTotalAllTopics } = useTopicsIndexContext();
  const params = { [PARAM_SUGGESTED_FOR_USER]: true };
  const {
    topics,
    totalTopics,
    isFetchingTopics,
    setPage,
    handleFetchTopics,
    updateTopicApproval,
  } = useTopics({ params });
  const name = s__('Topics|Suggested for you');

  const loadNextPage = useCallback(
    () => setPage((previousPage) => previousPage + 1),
    [],
  );

  useEffect(() => {
    setTotalAllTopics({
      ...totalAllTopics,
      [SUGGESTED_TOPICS]: {
        totalTopics,
        isFetchingTopics,
      },
    });
  }, [totalTopics, isFetchingTopics]);

  return {
    name,
    topics: topics.map((topic) => ({
      ...topic,
      category_lane: PARAM_SUGGESTED_FOR_USER,
      typeTopic: SUGGESTED_TOPICS,
    })),
    totalTopics,
    isFetchingTopics,
    params,
    loadNextPage,
    handleFetchTopics,
    updateTopicApproval,
  };
};

export default useTopicsSuggestedTopics;
